
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Layout, Menu } from 'ant-design-vue';
import LanguageSwitch from '@/UI/components/brand/LanguageSwitch.vue';
import PultLogo from '@/UI/components/brand/PultLogo.vue';
import { AuthStore } from '@/store/modules/Auth';
import { changeCompany } from '@/plugins/Http';
@Component({ components: { LanguageSwitch, PultLogo, 'a-layout-header': Layout.Header, 'a-menu': Menu, 'a-menu-item': Menu.Item, 'a-menu-divider': Menu.Divider } })
export default class Header extends Vue {
    @Prop({ default: false }) readonly darkTheme!: boolean;
    @Prop({ default: false }) readonly menuOpen!: boolean;
    get userData(): any { return AuthStore.userData || {}; }
    selectCompany(id: number | string): void { changeCompany(id); }
    async actionExit(): Promise<void> { AuthStore.clearUserData(); await AuthStore.logout(); }
    async created(): Promise<void> { await AuthStore.fetchManual(); }
}
